import { CorporateLinkageScore } from './corporateLinkageScore'
import { PerformanceScore } from './performanceScore'

export const PremiumComponent = () => {
  return (
    <div>
      {/* <CreditRiskScore /> */}
      <PerformanceScore />
      <CorporateLinkageScore />
    </div>
  )
}
